import { WEBHOOK_DELIVERIES_COLUMN_ID } from "../constants";
import WebhookDeliveriesTableDropdownCell from "./DropdownCell";
import WebhookDeliveriesTableIdCell from "./IdCell";
import WebhookDeliveriesTableStatusCell from "./StatusCell";
import WebhookDeliveriesTableTimestampCell from "./TimestampCell";

const WEBHOOK_DELIVERIES_TABLE_CELLS = {
  [WEBHOOK_DELIVERIES_COLUMN_ID.ID]: WebhookDeliveriesTableIdCell,
  [WEBHOOK_DELIVERIES_COLUMN_ID.STATUS]: WebhookDeliveriesTableStatusCell,
  [WEBHOOK_DELIVERIES_COLUMN_ID.TIMESTAMP]: WebhookDeliveriesTableTimestampCell,
  [WEBHOOK_DELIVERIES_COLUMN_ID.DROPDOWN]: WebhookDeliveriesTableDropdownCell,
};

export default WEBHOOK_DELIVERIES_TABLE_CELLS;
